import { useEffect, useRef } from 'react'

/**
 * Hook to use Polling
 *
 * @param {*} {
 *   pollingFn,
 *   pollingTimeInSeconds = 5,
 *   dependencies = [],
 * }
 * @returns
 */
function usePolling({ pollingFn, pollingTimeInSeconds = 5, dependencies = [] }) {
  const interval = useRef(null)
  function cancelPolling() {
    clearInterval(interval.current)
  }
  useEffect(() => {
    if (interval.current) {
      clearInterval(interval.current)
    }
    pollingFn()
    interval.current = setInterval(() => {
      pollingFn()
    }, pollingTimeInSeconds * 1000)

    return () => clearInterval(interval.current)
    // eslint-disable-next-line
  }, [dependencies])
  return cancelPolling
}

export default usePolling
